import * as Sentry from '@sentry/react'

import { isApostraAdminHost } from './components/adminAuthBrand'
import { loadProductBrandGatewayConfig } from './runtime-product-brand-config'

if (isApostraAdminHost()) {
  document.title = 'Apostra Admin'
}

let runtimeConfigurationLoaded = false
let preloadFailure = false
let terminalFailure: Promise<void> | undefined
const BOOTSTRAP_PRELOAD_RELOAD_GUARD = `bootstrap-preload-reload:${window.location.href}:${import.meta.url}`

function showTerminalError(failureClass?: 'preload'): Promise<void> {
  terminalFailure ??= (async () => {
    window.removeEventListener('vite:preloadError', handleBootstrapPreloadError)
    try {
      if (import.meta.env.VITE_SENTRY_DSN) {
        Sentry.init({
          dsn: import.meta.env.VITE_SENTRY_DSN,
          environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
          integrations: [],
          sendDefaultPii: false,
          beforeSend(event) {
            delete event.request
            delete event.breadcrumbs
            return event
          },
        })
        Sentry.captureMessage(
          'Runtime gateway configuration bootstrap failed',
          {
            level: 'fatal',
            tags: {
              ...(failureClass
                ? { runtime_gateway_configuration_failure: failureClass }
                : {}),
              startup_phase: 'runtime_gateway_configuration',
            },
          },
        )
        await Sentry.flush(2_000)
      }
    } catch {
      // The terminal error remains visible even if monitoring is unavailable.
    }

    const alert = document.createElement('main')
    alert.setAttribute('role', 'alert')
    alert.textContent =
      'This application could not load its secure configuration. Refresh the page to try again.'
    document.body.replaceChildren(alert)
  })()
  return terminalFailure
}

const handleBootstrapPreloadError = (event: Event) => {
  event.preventDefault()
  if (!sessionStorage.getItem(BOOTSTRAP_PRELOAD_RELOAD_GUARD)) {
    sessionStorage.setItem(BOOTSTRAP_PRELOAD_RELOAD_GUARD, '1')
    window.location.reload()
  } else {
    preloadFailure = true
    void showTerminalError('preload')
  }
}

window.addEventListener('vite:preloadError', handleBootstrapPreloadError)

try {
  await loadProductBrandGatewayConfig()
  if (preloadFailure) {
    await showTerminalError('preload')
  } else {
    runtimeConfigurationLoaded = true
  }
} catch {
  await showTerminalError()
}

if (runtimeConfigurationLoaded) {
  await import('./main')
  sessionStorage.removeItem(BOOTSTRAP_PRELOAD_RELOAD_GUARD)
}
